"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContextColorClass = void 0;
var colors_1 = require("../@types/colors");
var getContextColorClass = function (context) {
    if (Object.values(colors_1.ContextTypes).includes(context)) {
        return "nebraska-context-color-".concat(context);
    }
    else {
        return null;
    }
};
exports.getContextColorClass = getContextColorClass;
